export class ButtonList extends HTMLElement {
  constructor() {
    super();
    this.dataset.scrollBound = "true"; // mark as bound

    this.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href");
      if (!href || !href.includes("#")) return;

      event.preventDefault();
      this.handleScroll(href);
    });
  }

  handleScroll(targetSelector) {
    const element = document.querySelector(targetSelector);
    if (!element) return;

    element.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  }
}

customElements.define("button-list", ButtonList);
